import React, { useEffect, useState } from "react";
import serviceApi from "../../../services/serviceApi";
import environment from "../../../environments/environment";

const PTMContent: React.FC = () => {
    const [ptms, setPtms] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        const PTMs = async () => {
            setIsLoading(true);
            try {
                const res = await serviceApi.get(environment.ptm);
                if (res && res.status === "SUCCESS") {
                    setPtms(res.dataList || []);
                }
            } catch (err) {
                console.error("PTM Fetch Error:", err);
            } finally {
                setIsLoading(false);
            }
        };
        PTMs();
    }, []);

    if (isLoading) {
        return (
            <div className="loading-overlay">
                <div className="loading-overlay__content">
                    <div className="spinner spinner--lg"></div>
                    <span className="loading-text">Loading PTMs...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="notification-page">
            <h2 className="title-text notification-heading">PTM Sessions</h2>
            <div>
                {ptms.map((ptm) => (
                    <div key={ptm.id} className="event-container" >
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <i className="fa-regular fa-calendar-check" style={{ color: "var(--colorAccent)", fontSize: "14px" }}></i>
                            <span className="event-date" style={{ fontSize: "13px", color: "#333", fontWeight: "bold", position: 'static' }}>
                                {ptm.date} | {ptm.time}
                            </span>
                        </div>
                        <h3 className="title-text" style={{ margin: "8px 0 4px 0", color: "var(--colorPrimaryDark)" }}>
                            {ptm.title}
                        </h3>
                        <hr style={{ border: "0", borderTop: "1px solid #eee", margin: "12px 0" }} />
                        <p className="event-description" style={{ margin: "0 0 20px 0", color: "#555" }}>
                            {ptm.description}
                        </p>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                            <div style={{ paddingBottom: "5px" }}>
                                <span style={{
                                    fontSize: "10px",
                                    fontWeight: "bold",
                                    color: ptm.status === "CLOSED" ? "#f44336" : "#4caf50",
                                    border: `1px solid ${ptm.status === "CLOSED" ? "#f44336" : "#4caf50"}`,
                                    padding: "2px 6px",
                                    borderRadius: "4px",
                                    textTransform: "uppercase"
                                }}>
                                    {ptm.status || "PLANNED"}
                                </span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <div style={{ textAlign: "right" }}>
                                    <div style={{ fontSize: "10px", color: "#999" }}>IN-CHARGE</div>
                                    <div style={{ fontSize: "12px", fontWeight: "bold", color: "#333" }}>{ptm.incharge}</div>
                                </div>
                                <div style={{
                                    width: "38px", height: "38px", borderRadius: "8px",
                                    backgroundColor: "#f0f4f8", border: "1px solid #ddd",
                                    display: "flex", alignItems: "center", justifyContent: "center"
                                }}>
                                    <i className="fa-solid fa-user-tie" style={{ color: "var(--colorPrimary)", fontSize: "18px" }}></i>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PTMContent;